
import Vue from 'vue'
import Component from 'vue-class-component'

import TempAccount from '@/models/tempAccount'
import TempAccountService from '@/services/TempAccountService'

import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

const Props = Vue.extend({
  props: {
    onClose: Function,
  },
})

@Component({
  components: {
    ProgressLinear,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class TempAccountChangeStatus extends Props {
  private dialog: boolean = false
  private isPending: boolean = false

  private tempAccount: TempAccount = {} as TempAccount

  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService

  public show(account: TempAccount) {
    this.tempAccount = account
    this.dialog = true
  }

  private hide() {
    this.onClose()
    this.dialog = false
  }

  private async changeAccountStatusTempAccount() {
    this.isPending = true
    try {
      if (this.tempAccount.ad_est_actif === true) {
        await TempAccountService.disable(
          this.tempAccount.ad_personne_id,
          this.tempAccount.identifiant,
        )
        this.$notificationService.success(
          this.$t('TEMPACCOUNT.DisableSuccess').toString(),
        )
        this.tempAccount.ad_est_actif = false
        this.hide()
      } else if (this.tempAccount.ad_est_actif === false) {
        await TempAccountService.enable(
          this.tempAccount.ad_personne_id,
          this.tempAccount.identifiant,
        )
        this.$notificationService.success(
          this.$t('TEMPACCOUNT.EnableSuccess').toString(),
        )
        this.tempAccount.ad_est_actif = true
        this.hide()
      }
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
    this.isPending = false
  }
}
